/* 🤖 this file was generated by svg-to-ts*/
export const icoCodeAlt: {
  name: 'code-alt';
  data: string;
} = {
  name: 'code-alt',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.275 4.038a1 1 0 01.712 1.123l-.026.114-4 14a1 1 0 01-1.948-.436l.025-.114 4-14a1 1 0 011.237-.687zM7.707 7.293a1 1 0 01.083 1.32l-.083.094L4.415 12l3.292 3.293a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.32.083l-.094-.083-4-4a1 1 0 01-.083-1.32l.083-.094 4-4a1 1 0 011.414 0zm8.586 0a1 1 0 011.32-.083l.094.083 4 4 .083.094a1 1 0 010 1.226l-.083.094-4 4-.094.083a1 1 0 01-1.226 0l-.094-.083-.083-.094a1 1 0 010-1.226l.083-.094L19.585 12l-3.292-3.293-.083-.094a1 1 0 01.083-1.32z" fill="#909090"/></svg>`
};
